const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTruck(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "256px",
    height: "256px",
    style: {
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.02
    },
    fill: "#0db8b1",
    d: "M 100.5,37.5 C 85.1667,37.5 69.8333,37.5 54.5,37.5C 63.4827,35.8951 72.6494,34.5617 82,33.5C 88.4886,33.9652 94.6553,35.2985 100.5,37.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#254571",
    d: "M 255.5,125.5 C 255.5,142.833 255.5,160.167 255.5,177.5C 251.132,185.086 244.465,188.086 235.5,186.5C 233.692,187.918 233.025,189.918 233.5,192.5C 231.207,205.629 223.54,213.795 210.5,217C 192.757,219.386 180.924,212.219 175,195.5C 174.503,192.854 174.336,190.187 174.5,187.5C 157.185,186.604 139.852,186.271 122.5,186.5C 116.5,186.5 110.5,186.5 104.5,186.5C 95.1667,186.5 85.8333,186.5 76.5,186.5C 76.2602,202.243 68.5936,212.409 53.5,217C 40.712,219.294 30.212,215.461 22,205.5C 19.4246,202.274 17.9246,198.607 17.5,194.5C 17.977,191.083 16.977,188.416 14.5,186.5C 7.42167,186.8 2.42167,183.8 -0.5,177.5C -0.5,136.5 -0.5,95.5 -0.5,54.5C 2.64896,46.5191 8.31563,41.0191 16.5,38C 29.1623,37.5001 41.8289,37.3334 54.5,37.5C 69.8333,37.5 85.1667,37.5 100.5,37.5C 101.908,36.9386 103.408,36.6052 105,36.5C 121.218,36.9924 137.384,37.8257 153.5,39C 165.479,45.1229 170.479,54.9562 168.5,68.5C 179.172,68.3335 189.839,68.5002 200.5,69C 206.799,70.9633 211.632,74.7966 215,80.5C 219.667,89.8333 224.333,99.1667 229,108.5C 235.941,112.375 243.107,115.875 250.5,119C 252.55,120.965 254.217,123.132 255.5,125.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#0db7b1",
    d: "M 18.5,49.5 C 61.8346,49.3333 105.168,49.5 148.5,50C 152.333,51.1667 154.833,53.6667 156,57.5C 156.5,82.1644 156.667,106.831 156.5,131.5C 108.166,131.667 59.8322,131.5 11.5,131C 10.3396,107.573 10.1729,84.0726 11,60.5C 11.7639,55.5824 14.2639,51.9157 18.5,49.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#0db7b1",
    d: "M 168.5,80.5 C 179.27,80.0471 189.937,80.5471 200.5,82C 201.667,83.1667 202.833,84.3333 204,85.5C 207.578,92.9909 211.412,100.324 215.5,107.5C 199.848,108.499 184.181,108.833 168.5,108.5C 168.5,99.1667 168.5,89.8333 168.5,80.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#0cb7b1",
    d: "M 168.5,120.5 C 187.836,120.333 207.17,120.5 226.5,121C 232.075,123.371 237.575,125.871 243,128.5C 244.135,136.067 244.635,143.734 244.5,151.5C 244.333,158.5 244.167,165.5 244,172.5C 243.5,173.667 242.667,174.5 241.5,175C 234.459,177.35 229.626,175.183 227,168.5C 217.675,158.73 206.509,155.897 193.5,160C 186.258,162.778 180.925,167.611 177.5,174.5C 174.572,175.484 171.572,175.817 168.5,175.5C 168.5,157.167 168.5,138.833 168.5,120.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.999
    },
    fill: "#0cb7b1",
    d: "M 10.5,142.5 C 59.1667,142.5 107.833,142.5 156.5,142.5C 156.5,153.5 156.5,164.5 156.5,175.5C 128.831,175.667 101.165,175.5 73.5,175C 62.0148,157.253 47.0148,153.586 28.5,164C 24.7435,167.086 21.7435,170.752 19.5,175C 16.0006,176.12 13.1672,175.287 11,172.5C 10.5002,162.506 10.3335,152.506 10.5,142.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.999
    },
    fill: "#0db7b1",
    d: "M 42.5,169.5 C 58.1648,169.329 65.3314,176.996 64,192.5C 58.4703,205.344 49.3036,208.844 36.5,203C 27.758,195.432 26.258,186.598 32,176.5C 34.9978,173.262 38.4978,170.929 42.5,169.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.999
    },
    fill: "#0cb7b1",
    d: "M 199.5,169.5 C 215.159,168.66 222.659,175.993 222,191.5C 216.121,205.684 206.288,209.184 192.5,202C 183.072,191.451 183.739,181.451 194.5,172C 196.315,171.243 197.981,170.41 199.5,169.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.068
    },
    fill: "#0cbbb5",
    d: "M 14.5,186.5 C 16.977,188.416 17.977,191.083 17.5,194.5C 16.0075,192.098 15.0075,189.431 14.5,186.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.004
    },
    fill: "#0db8b1",
    d: "M 104.5,186.5 C 110.5,186.5 116.5,186.5 122.5,186.5C 120.651,187.837 118.484,188.503 116,188.5C 111.978,188.108 108.145,187.442 104.5,186.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.15
    },
    fill: "#0db8b0",
    d: "M 235.5,186.5 C 234.952,188.626 234.285,190.626 233.5,192.5C 233.025,189.918 233.692,187.918 235.5,186.5 Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTruck);
export default __webpack_public_path__ + "static/media/truck.82a52aca27f5866a4cdc0b58c844f05e.svg";
export { ForwardRef as ReactComponent };